<template>
    <div class="inner-wrapper">
        <div class="title-wrapper">
          <span>{{base_info.title_ch}}</span>
        </div>
        <van-list
          v-model="projectTable.loading"
          :finished="projectTable.finished"
          finished-text="没有更多了"
          :error.sync="projectTable.error"
          error-text="请求失败，点击重新加载"
          @load="onLoad"
        >
          <van-cell
            v-for="item in projectTable.tivdata"
            :key="item.project_display_no+'verify'"
            is-link
            :url="'/sampleReceive/'+item.project_display_no"
          >
          <template slot="title">
            <a :href="'/contract_stat/'+item.project_display_no">{{projectDisplayNoAbbr(item.project_display_no)}}</a>
          </template>
          <template slot="label">
            <p>{{item.company_name}}</p>
            <p>{{item.customer_name+','+item.customer_account}}</p>
            <p>{{(item.remark&&JSON.parse(item.remark).customer)?('备注：'+JSON.parse(item.remark).customer):''}}</p>
          </template>
          <span class="cell-item">{{item.create_time}}</span>
          </van-cell>
        </van-list>
    </div>
</template>
<script>
let userToken = localStorage.getItem("current_user_token");
import { textTrans } from "@/mixins/TextTrans.js";

const OPTIONDATA = {
  period:[
    {text:'全部限期',value:''},
    {text:'当前逾期',value:'-1'},
    {text:'接近逾期',value:'1'},
    {text:'历史逾期',value:'history-1'},
  ],
  test_stat:[
    {text:'全部状态',value:''},
    {text:'待收样',value:'待收样'},
    {text:'检测中',value:'检测中'},
    {text:'已完成',value:'已完成'},
  ],
  pay_stat:[
    {text:'全部付款',value:''},
    {text:'未付款',value:'未付款'},
    {text:'部分付款',value:'部分付款'},
    {text:'已付款',value:'已付款'},
  ],
  invoice_stat:[
    {text:'全部发票',value:''},
    {text:'未开具',value:'未开具'},
    {text:'已申请',value:'已申请'},
    {text:'已开具',value:'已开具'},
  ],
  customer_company_catagory:[
    {text:'全部客户',value:''},
    {text:'铁道工程',value:'E'},
    {text:'金属材料',value:'M'},
    {text:'无损检测',value:'N'},
  ],
  date_type:[
    {text:'要求日期',value:'demand_date'},
    {text:'委托日期',value:'create_date'},
  ],
  order:[
    {text:'默认排序',value:''},
    {text:'要求日期',value:'demand'},
    {text:'委托日期',value:'create'},
  ],
  esc:[
    {text:'排序方向',value:'DESC'},
    {text:'倒序',value:'DESC'},
    {text:'顺序',value:'ESC'}
  ]
}

function optionDataFac(){
  return {
    project_display_no:'',
    test_stat:OPTIONDATA.test_stat[0].value,
    pay_stat:OPTIONDATA.pay_stat[0].value,
    invoice_stat:OPTIONDATA.invoice_stat[0].value,
    customer_company_catagory:OPTIONDATA.customer_company_catagory[0].value,
    period:OPTIONDATA.period[0].value,
    date_type:OPTIONDATA.date_type[0].value,
    start_date:'',
    end_date:'',
    keyword:'',
    order:'',
    esc:OPTIONDATA.esc[0].value
  };
}

export default {
  name: "projectReceive",
  components: {
  },
  mixins: [textTrans],
  props: {},
  data() {
    return {
      base_info:{
        askData: "projectReceiveList",
        post_url:'/ask_list_data',
        title_cn:"检测项目接收"
      },
      optionData:optionDataFac(),
      projectTable: {
        loading: false,
        finished: false,
        error: false,
        Tpage: {
          currentPage: 1,
          currentSize: 20
        },
        no_data_text: "",
        totalItems: 0,
        tivdata: [
          /*{
            contract_no: NaN,
            report_display_no:NaN,
            report_no: NaN,
            reporter: "",
            report_date: ""
          }*/
        ]
      }
      
    };
  },
  watch: {
  },
  computed: {},
  created() {
  },
  methods: {
    onLoad() {
      this.projectTable.loading = true;
      this.$axios
        .post(this.$url + this.base_info.post_url, {
          page: this.projectTable.Tpage,
          userToken: userToken,
          ask_data: this.base_info.askData,
          optionData:this.optionData,
        })
        .then(response => {
          for(let ele of response.data.res_record){
            this.projectTable.tivdata.push(ele);
          }
          if(response.data.res_record.length<this.projectTable.Tpage.currentSize){
            this.projectTable.finished = true
          }
          this.projectTable.loading = false;
          this.projectTable.Tpage.currentPage++;
        });
    },
  }
};
</script>
<style scoped>
.inner-wrapper {
  width: 100%;
  background: #f7f7f7;
  min-height:20rem;
}

.title-wrapper {
  text-align: center;
  font-size: 0.8rem;
  color:#999;
  padding: 1rem;
  background: #fff;
  border-bottom:1px solid #f6f6f6;
}

.cell-item{
  margin-left:0.6rem;
}
</style>